import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import theme from "styles/theme";
import Dialog from "components/dialog";
import Globalize from "globalize";
import Text from "components/form/text-inline";
import debounce from "lodash/debounce";
import { style, merge, $ } from "glamor";
import { DATATEST } from "constants/integration";
import _ from "lodash";

const Image = ({ item, imageStyle, scope }) => {
    const image = item.getImageUrl(scope, "T", 0);
    if (image) {
        return <img role="presentation" src={image} {...imageStyle} />;
    }
    return null;
};

class AddNotes extends PureComponent {
    static propTypes = {
        catalogEntryId: PropTypes.string,
        entities: PropTypes.object,
        scope: PropTypes.object.isRequired,
    };

    styles = {
        row: merge(
            {
                display: "block",
                padding: "8px 8px 0px 56px",
                position: "relative",
                height: "64px",
                margin: "0 0 12px",
            },
            $(" .primary", {
                color: theme.palette.darkerGrey,
                fontSize: "14px",
                lineHeight: "18px",
            }),
            $(" .secondary", {
                color: theme.palette.darkGrey,
                fontSize: "12px",
                lineHeight: "14px",
            }),
        ),
        image: style({
            position: "absolute",
            top: "5px",
            left: "0px",
            zIndex: 3,
            height: "52px",
        }),
        dialogContent: {
            maxWidth: "504px",
        },
        description: {
            margin: "0px",
        },
        descriptionEditor: {
            minHeight: "80px",
        },
    };

    constructor(props) {
        super(props);
        this.state = {
            notes: "",
            item: null,
            entry: null,
        };

        this.handleNotesChange = debounce(this.handleNotesChange.bind(this), 600);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.catalogEntryId !== this.props.catalogEntryId) {
            const catalogEntryId = nextProps.catalogEntryId;
            const entry = catalogEntryId && _.get(nextProps, `entities.entries.${catalogEntryId}`);
            const item = entry && _.get(nextProps, `entities.items.${entry.item || entry.item_id}`);
            const notes = entry && entry.notes;

            this.setState({
                notes: notes || "",
                entry: entry || null,
                item: item || null,
            });
        }
    }

    handleNotesChange(notes) {
        const { onUpdate } = this.props;
        const { entry } = this.state;
        if (entry) {
            onUpdate(entry, { notes });
        }
    }

    render() {
        const { editable, catalogEntryId, onRequestClose, scope } = this.props;
        const { notes, item } = this.state;

        if (!catalogEntryId) {
            return null;
        }

        return (
            <Dialog modal={false} open={true} onRequestClose={onRequestClose} contentStyle={this.styles.dialogContent}>
                <div {...this.styles.row} key="item">
                    {!!item && <Image key="image" item={item} imageStyle={this.styles.image} scope={scope} />}
                    <div key="details">
                        <div className="primary" key="name">
                            {_.get(item, "name")}
                        </div>
                        <div className="secondary" key="style">
                            {_.get(item, "style_number")}
                        </div>
                    </div>
                </div>
                <Text
                    key="notes"
                    dataTest={DATATEST.CATALOG.DIALOG_NOTES_INPUT}
                    style={this.styles.description}
                    editorStyle={this.styles.descriptionEditor}
                    placeholder={Globalize.formatMessage("Add notes here")}
                    editable={editable}
                    form={true}
                    defaultValue={notes}
                    onChange={this.handleNotesChange}
                    label={Globalize.formatMessage("Product Notes")}
                />
            </Dialog>
        );
    }
}

export default AddNotes;
